import { ForegroundColor, FOREGROUNDCOLOR } from "../../helpers/colors";
import { Button, TextField } from "@mui/material";
import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useMemo, useState } from "react";
import { Link, redirect, useNavigate } from "react-router-dom";
import { CreateCompany, GetCompanies } from "../../services/CompanyService";
import {
  GetMyPosition,
  GetPositionRoleByPositionIdAndRole,
} from "../../services/PositionService";
import NoPosition from "../../assets/vectors/NoPositionVector.png";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import noImage from "../../assets/vectors/no-image.svg";
import CustomLabel from "../share/customLabel";
import { ColorPalette } from "../share/color/colorPalette";
const CompaniesView = () => {
  const formik = useFormik({
    initialValues: {
      id: null,
      name: "",
      registrationCode: "",
      description: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("نام فروشگاه را وارد کنید"),
      registrationCode: Yup.string().required("  شماره ملی  را وارد کنید"),
      //description: Yup.string().required("لطفا توضیحات را وارد کنید"),
    }),
    onSubmit: (values) => {
      console.log(values);
      CreateCompanyAsync(values);
      SetShowModal(false);
    },
  });
  async function CreateCompanyAsync(params: any) {
    await CreateCompany(params).then((p) => GetMyPositionAsync());
  }
  const [data, setData] = useState(null);
  const [showModal, SetShowModal] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    GetMyPositionAsync();
    dispatch(fetchUserPosition());
    if (localStorage.getItem("token") === null) {
      navigate("/login");
      return;
    }
  }, []);

  /* Start Of Checking User Has Position */
  const [myPosition, SetMyPosition] = useState<any>("");
  async function GetMyPositionAsync() {
    await GetMyPosition().then((p) => {
      //console.log("log", p.data.company.id);

      if (p.status === 200) {
        SetMyPosition(p.data);
        formik.setFieldValue("id", p.data.company.id);
        formik.setFieldValue("name", p.data.company.name);
        formik.setFieldValue("description", p.data.company.description);
        formik.setFieldValue(
          "registrationCode",
          p.data.company.registrationCode
        );
      } else {
        SetMyPosition(null);
      }
    });
  }

  const [EditCompanyProfile, setEditCompanyProfile] = useState(false);

  const dispatch = useDispatch<any>();
  const myPositions = useSelector(getMyPosition);

  async function GetPositionRoleByPositionIdAndRoleAsync3() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "EditCompanyProfile"
    ).then((p) => {
      console.log("setEditCompanyProfile", p.data.data);

      setEditCompanyProfile(p.data.data);
    });
  }
  useEffect(() => {
    //console.log(myPositions);

    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync3();
      }
    }
  }, [myPositions]);

  /* End Of Checking  */

  const columns = useMemo(
    () => [
      {
        field: "Id",
        hide: true,
        filter: true,
      },
      {
        field: "Name",
        headerName: "فروشگاه",
        filter: true,
      },
      {
        field: "RegistrationCode",
        headerName: "شماره ثبت",
        filter: true,
      },
      {
        field: "Status",
        headerName: "وضعیت",
        filter: true,
      },
      {
        field: "CreatedUser",
        headerName: "ثبت شده توسط",
        filter: true,
      },
      {
        field: "RelationToUser",
        headerName: " مسئولیت ",
        filter: true,
      },
      {
        field: "Id",
        headerName: " تاریخچه ",
        filter: false,
        sortable: false,
      },
    ],
    []
  );

  return (
    <>
      {myPosition !== null ? (
        <>
          <br />
          <div style={{ marginRight: "50px", display: "inline-flex" }}>
            <div>
              <img height={200} width={200} src={noImage} alt="CompanyLogo" />
            </div>
            <div
              style={{
                height: "70px",
                width: "200px",
                backgroundColor: "transparent",
                marginRight: "20px",
                marginTop: "130px",
              }}
            >
              <CustomLabel style={{ color: ColorPalette.gray[700] }}>
                نام فروشگاه
              </CustomLabel>
              <br />

              <CustomLabel style={{ color: ColorPalette.gray[900] }}>
                {myPosition?.company?.name}
              </CustomLabel>
            </div>
          </div>
          <br />
          <div
            style={{
              height: "70px",

              backgroundColor: "transparent",
              marginRight: "50px",
              marginTop: "50px",
              display: "inline-flex",
            }}
          >
            <div style={{ marginLeft: "200px" }}>
              <CustomLabel style={{ color: ColorPalette.gray[700] }}>
                شماره ملی
              </CustomLabel>
              <br />

              <CustomLabel style={{ color: ColorPalette.gray[900] }}>
                {myPosition?.company?.registrationCode}
              </CustomLabel>
            </div>
            <div>
              <CustomLabel style={{ color: ColorPalette.gray[700] }}>
                توضیحات
              </CustomLabel>
              <br />

              <CustomLabel style={{ color: ColorPalette.gray[900] }}>
                {myPosition?.company?.description}
              </CustomLabel>
            </div>
          </div>
        </>
      ) : (
        <>
          <div style={{ textAlign: "center", margin: "auto" }}>
            <div
              className="col-12 mt-5 iran  "
              style={{ textAlign: "center", margin: "auto" }}
            >
              <p>کاربر گرامی شما دارای هیچ سمتی در هیچ فروشگاهی نمیباشید . </p>
              <img height={150} width={150} src={NoPosition} />
            </div>
            <div
              className="col-12  "
              style={{ textAlign: "center", alignItems: "center" }}
            >
              <div className="col-12">
                <b className="iran" style={{ color: ForegroundColor }}>
                  اگر دارای فروشگاه هستید ، میتوانید از لینک زیر آنرا ثبت کنید
                </b>
              </div>
              <div className="mt-5 col-12">
                <Button
                  onClick={() => SetShowModal(true)}
                  variant="contained"
                  color="info"
                >
                  {" "}
                  ثبت فروشگاه{" "}
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
      <Dialog
        id="test"
        style={{ width: "50vw" }}
        visible={showModal}
        onHide={() => SetShowModal(false)}
      >
        <>
          <div className="mt-5 mb-5 container">
            <b>
              در نظر داشته باشید اطلاعات فروشگاه قابل ویرایش نمیباشند لطفا در
              وارد کردن اطلاعات دقت فرمایید
            </b>
            <hr />
            <div className="card p-2">
              <div className="col-12 col-lg-12  col-xs-12">
                <TextField
                  disabled={myPosition?.company?.name.length > 0}
                  className="iran col-12"
                  id="name"
                  type="text"
                  placeholder="نام فروشگاه"
                  {...formik.getFieldProps("name")}
                />
                {formik.touched.name && formik.errors.name ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="iran my-1 mx-2 text-danger"
                  >
                    {formik.errors.name}
                  </b>
                ) : null}
              </div>
            </div>

            <div className="card mt-2 p-2">
              <div className="col-12 col-lg-12  col-xs-12">
                <TextField
                  disabled={myPosition?.company?.registrationCode.length > 0}
                  className="iran col-12"
                  id="registrationCode"
                  type="text"
                  placeholder="شماره ملی"
                  {...formik.getFieldProps("registrationCode")}
                />
                {formik.touched.registrationCode &&
                formik.errors.registrationCode ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="iran my-1 mx-2 text-danger"
                  >
                    {formik.errors.registrationCode}
                  </b>
                ) : null}
              </div>
            </div>
            <div className="card mt-2 p-2">
              <div className="col-12 col-lg-12  col-xs-12">
                <TextField
                  className="iran col-12"
                  id="description"
                  type="text"
                  multiline
                  placeholder="توضیحات"
                  {...formik.getFieldProps("description")}
                />
                {formik.touched.description && formik.errors.description ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="iran my-1 mx-2 text-danger"
                  >
                    {formik.errors.description}
                  </b>
                ) : null}
              </div>
            </div>
            <div className="col-12 mt-2 px-2" style={{ width: "100%" }}>
              <Button
                onClick={formik.submitForm}
                variant="outlined"
                color="success"
                className="mx-2 iran"
              >
                ذخیره
              </Button>
              <Button
                onClick={() => SetShowModal(false)}
                variant="outlined"
                color="warning"
                className="mx-2 iran"
              >
                انصراف
              </Button>
            </div>
          </div>
        </>
      </Dialog>
    </>
  );
};

export default CompaniesView;
